export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      about: "À propos",
      services: "Services",
      vision: "Notre Vision",
      mission: "Notre Mission",
      portfolio: "Portefeuille",
      team: "Équipe",
      contact: "Contact",
      quote: "Demander un devis"
    },
    hero: {
      title: "KEYAN EXPERTISE",
      subtitle: "Bâtiment • Immobilier • Services Techniques",
      description: "Des experts pour votre satisfaction !",
      cta: "Demander un devis",
      ctaSecondary: "Découvrir nos services"
    },
    about: {
      title: "À propos de nous",
      description: "KEYAN EXPERTISE est une société polyvalente qui propose une gamme complète de services dans les domaines du Bâtiment, de l'Immobilier et des Services Techniques. Notre engagement est de garantir des prestations de haute qualité, soutenues par une équipe de professionnels expérimentés, pour assurer la satisfaction totale de nos clients.",
      activities: {
        title: "À propos de nos activités",
        description: "KEYAN EXPERTISE se positionne comme un acteur majeur grâce à la diversité et la complémentarité de ses métiers. Nous offrons une solution globale pour tous vos projets."
      }
    },
    services: {
      title: "Nos Services",
      subtitle: "Une expertise complète pour tous vos projets",
      items: [
        {
          title: "Construction Spécialisée",
          subtitle: "Métallique, Aluminium, Inox, Alucobond",
          features: [
            "Construction Métallique : Charpentes, hangars, structures industrielles",
            "Menuiserie Aluminium & Inox : Portes, fenêtres, garde-corps, façades",
            "Alucobond : Habillage de façades pour un design moderne et une isolation optimisée"
          ]
        },
        {
          title: "Bâtiment et Travaux Publics",
          subtitle: "BTP",
          features: [
            "Conception : Études architecturales et techniques",
            "Construction : Bâtiments neufs (résidentiels, commerciaux, industriels)",
            "Rénovation : Réhabilitation, modernisation et extension de structures existantes"
          ]
        },
        {
          title: "Gestion Immobilière",
          subtitle: "Services complets",
          features: [
            "Administration de biens (gérance locative)",
            "Syndic de copropriété",
            "Transactions immobilières (achat, vente, location)"
          ]
        },
        {
          title: "Sécurité Résidentielle et Professionnelle",
          subtitle: "Protection optimale",
          features: [
            "Systèmes d'alarme et de surveillance vidéo (CCTV)",
            "Contrôle d'accès (interphones, digicodes, biométrie)",
            "Portails et clôtures sécurisés"
          ]
        },
        {
          title: "Froid et Climatisation",
          subtitle: "Confort thermique",
          features: [
            "Installation de climatiseurs (split, centralisé, VRV)",
            "Entretien et dépannage des systèmes de réfrigération et de climatisation"
          ]
        },
        {
          title: "Électricité Bâtiment",
          subtitle: "Solutions électriques",
          features: [
            "Installation électrique (courants forts et faibles)",
            "Mise aux normes et rénovation des installations",
            "Maintenance et dépannage"
          ]
        }
      ]
    },
    vision: {
      title: "Notre Vision",
      items: [
        {
          title: "Expertise",
          description: "Une équipe qualifiée et expérimentée dans tous nos domaines d'intervention"
        },
        {
          title: "Qualité",
          description: "Utilisation de matériaux certifiés et respect des normes en vigueur"
        },
        {
          title: "Satisfaction Client",
          description: "Un accompagnement personnalisé et une écoute active de vos besoins"
        },
        {
          title: "Fiabilité",
          description: "Respect des délais et des engagements contractuels"
        }
      ]
    },
    mission: {
      title: "Notre Mission",
      description: "Concevoir, construire et entretenir des infrastructures fiables et modernes, en garantissant qualité, sécurité et satisfaction totale de nos clients, tout en favorisant l'expertise locale et l'innovation dans chacun de nos projets."
    },
    portfolio: {
      title: "Notre Portefeuille",
      subtitle: "Typologies d'ouvrages maîtrisées",
      items: [
        "Charpentes métalliques pour bâtiments industriels et entrepôts",
        "Structures métalliques pour ateliers, hangars et plateformes techniques",
        "Ouvrages métalliques secondaires : escaliers, garde-corps, passerelles",
        "Renforcement et réhabilitation de structures métalliques existantes",
        "Fabrication et montage de structures métalliques sur mesure"
      ],
      quality: {
        title: "Approche Qualité",
        items: [
          "Respect des normes techniques applicables",
          "Contrôle qualité rigoureux",
          "Priorité à la sécurité, aux délais et à la conformité contractuelle"
        ]
      }
    },
    team: {
      title: "Notre Équipe",
      subtitle: "Des professionnels à votre service",
      members: [
        {
          name: "Cédric G.",
          role: "Directeur Général"
        },
        {
          name: "Joelle K.",
          role: "Directrice Commerciale"
        },
        {
          name: "Mardochée K.",
          role: "Ingénieur Génie Civil"
        }
      ]
    },
    contact: {
      title: "Nos Contacts",
      subtitle: "Pour toute demande d'information, de devis ou de partenariat, n'hésitez pas à nous contacter.",
      info: {
        phone: "Téléphone",
        email: "Email",
        address: "Adresse"
      },
      form: {
        title: "Demande de Devis",
        name: "Nom complet",
        email: "Email",
        phone: "Téléphone",
        clientType: "Type de client",
        clientTypes: {
          particular: "Particulier",
          professional: "Professionnel",
          company: "Entreprise"
        },
        service: "Service souhaité",
        serviceOptions: {
          construction: "Construction Spécialisée",
          btp: "Bâtiment et Travaux Publics",
          realestate: "Gestion Immobilière",
          security: "Sécurité",
          hvac: "Froid et Climatisation",
          electrical: "Électricité Bâtiment"
        },
        message: "Description du projet",
        submit: "Envoyer la demande",
        sending: "Envoi en cours...",
        success: "Votre demande a été envoyée avec succès ! Nous vous contacterons rapidement.",
        error: "Une erreur est survenue. Veuillez réessayer."
      }
    },
    footer: {
      description: "Société polyvalente proposant une gamme complète de services dans les domaines du Bâtiment, de l'Immobilier et des Services Techniques.",
      quickLinks: "Liens rapides",
      services: "Services",
      contactUs: "Contactez-nous",
      rights: "Tous droits réservés.",
      slogan: "Des experts pour votre satisfaction !"
    },
    thanks: "MERCI POUR VOTRE CONFIANCE"
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      vision: "Our Vision",
      mission: "Our Mission",
      portfolio: "Portfolio",
      team: "Team",
      contact: "Contact",
      quote: "Request a Quote"
    },
    hero: {
      title: "KEYAN EXPERTISE",
      subtitle: "Building • Real Estate • Technical Services",
      description: "Experts for your satisfaction!",
      cta: "Request a Quote",
      ctaSecondary: "Discover our services"
    },
    about: {
      title: "About Us",
      description: "KEYAN EXPERTISE is a versatile company offering a complete range of services in the fields of Building, Real Estate and Technical Services. Our commitment is to guarantee high-quality services, supported by a team of experienced professionals, to ensure the total satisfaction of our clients.",
      activities: {
        title: "About Our Activities",
        description: "KEYAN EXPERTISE positions itself as a major player thanks to the diversity and complementarity of its trades. We offer a global solution for all your projects."
      }
    },
    services: {
      title: "Our Services",
      subtitle: "Complete expertise for all your projects",
      items: [
        {
          title: "Specialized Construction",
          subtitle: "Metal, Aluminum, Stainless Steel, Alucobond",
          features: [
            "Metal Construction: Frameworks, hangars, industrial structures",
            "Aluminum & Stainless Steel Joinery: Doors, windows, railings, facades",
            "Alucobond: Facade cladding for modern design and optimized insulation"
          ]
        },
        {
          title: "Building & Public Works",
          subtitle: "BTP",
          features: [
            "Design: Architectural and technical studies",
            "Construction: New buildings (residential, commercial, industrial)",
            "Renovation: Rehabilitation, modernization and extension of existing structures"
          ]
        },
        {
          title: "Real Estate Management",
          subtitle: "Complete services",
          features: [
            "Property administration (rental management)",
            "Condominium management",
            "Real estate transactions (purchase, sale, rental)"
          ]
        },
        {
          title: "Residential & Professional Security",
          subtitle: "Optimal protection",
          features: [
            "Alarm systems and video surveillance (CCTV)",
            "Access control (intercoms, digital codes, biometrics)",
            "Secure gates and fences"
          ]
        },
        {
          title: "HVAC & Refrigeration",
          subtitle: "Thermal comfort",
          features: [
            "Air conditioner installation (split, centralized, VRV)",
            "Maintenance and repair of refrigeration and air conditioning systems"
          ]
        },
        {
          title: "Building Electrical",
          subtitle: "Electrical solutions",
          features: [
            "Electrical installation (high and low current)",
            "Upgrading and renovation of installations",
            "Maintenance and troubleshooting"
          ]
        }
      ]
    },
    vision: {
      title: "Our Vision",
      items: [
        {
          title: "Expertise",
          description: "A qualified and experienced team in all our areas of intervention"
        },
        {
          title: "Quality",
          description: "Use of certified materials and compliance with current standards"
        },
        {
          title: "Customer Satisfaction",
          description: "Personalized support and active listening to your needs"
        },
        {
          title: "Reliability",
          description: "Respect for deadlines and contractual commitments"
        }
      ]
    },
    mission: {
      title: "Our Mission",
      description: "To design, build and maintain reliable and modern infrastructure, guaranteeing quality, safety and total satisfaction of our clients, while promoting local expertise and innovation in each of our projects."
    },
    portfolio: {
      title: "Our Portfolio",
      subtitle: "Types of structures mastered",
      items: [
        "Metal frameworks for industrial buildings and warehouses",
        "Metal structures for workshops, hangars and technical platforms",
        "Secondary metal works: stairs, railings, walkways",
        "Reinforcement and rehabilitation of existing metal structures",
        "Custom manufacturing and assembly of metal structures"
      ],
      quality: {
        title: "Quality Approach",
        items: [
          "Compliance with applicable technical standards",
          "Rigorous quality control",
          "Priority on safety, deadlines and contractual compliance"
        ]
      }
    },
    team: {
      title: "Our Team",
      subtitle: "Professionals at your service",
      members: [
        {
          name: "Cédric G.",
          role: "General Manager"
        },
        {
          name: "Joelle K.",
          role: "Commercial Director"
        },
        {
          name: "Mardochée K.",
          role: "Civil Engineer"
        }
      ]
    },
    contact: {
      title: "Contact Us",
      subtitle: "For any request for information, quote or partnership, do not hesitate to contact us.",
      info: {
        phone: "Phone",
        email: "Email",
        address: "Address"
      },
      form: {
        title: "Quote Request",
        name: "Full name",
        email: "Email",
        phone: "Phone",
        clientType: "Client type",
        clientTypes: {
          particular: "Individual",
          professional: "Professional",
          company: "Company"
        },
        service: "Desired service",
        serviceOptions: {
          construction: "Specialized Construction",
          btp: "Building & Public Works",
          realestate: "Real Estate Management",
          security: "Security",
          hvac: "HVAC & Refrigeration",
          electrical: "Building Electrical"
        },
        message: "Project description",
        submit: "Send request",
        sending: "Sending...",
        success: "Your request has been sent successfully! We will contact you shortly.",
        error: "An error occurred. Please try again."
      }
    },
    footer: {
      description: "A versatile company offering a complete range of services in the fields of Building, Real Estate and Technical Services.",
      quickLinks: "Quick Links",
      services: "Services",
      contactUs: "Contact Us",
      rights: "All rights reserved.",
      slogan: "Experts for your satisfaction!"
    },
    thanks: "THANK YOU FOR YOUR TRUST"
  }
};

export const companyInfo = {
  name: "KEYAN EXPERTISE",
  phones: ["+225 0707308654", "+225 0544056104", "+225 0102076060"],
  email: "contact@keyangroup.com",
  address: "Abidjan Cocody Riviera Akouedo ATCI Immeuble BETHEL face nouveau camp militaire",
  country: "Côte d'Ivoire"
};